import { AI_PRE_INTERVIEW, READ_ACTION } from '@/constants/resources'

export default [
  {
    path: '/pre-entrevista-ia/:id',
    name: 'ai-pre-interview-results',
    component: () =>
      import('@/modules/profile/views/AiPreInterviewResults.vue'),
    // Sem pageTitle/breadcrumb: a tela já tem cabeçalho próprio e os itens de
    // breadcrumb não tinham destino (QA). A navegação usa o name.
    meta: {
      resource: AI_PRE_INTERVIEW,
      action: READ_ACTION,
    },
  },
]
